import React from 'react';

import cs from 'classnames';
import styled from 'styled-components';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {useIsScreenLargerThan} from 'app/general/mediaqueries';
import StateButton from 'app/general/widgets/StateButton';
import {useLazySigner} from 'app/mediaaccess/api';
import {gt} from 'app/utils/i18n';

type FileProps = {
  MEDIA_URL_PROTECTED: string;
  file_ref: string;
  file_name: string;
};

export function FileAccessLink(props: FileProps) {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={`${props.MEDIA_URL_PROTECTED}${props.file_ref}`}
    >
      {props.file_name}
    </a>
  );
}

export function GuestFileAccessLink(props: FileProps) {
  const [trigger, {data, isFetching, isLoading}] = useLazySigner();
  const isBigScreen = useIsScreenLargerThan('sm');

  return (
    <LazyTooltip
      tooltip={gt(
        'This is a secured link to your file. If the link has expired, use the refresh button to generate a new link.'
      )}
    >
      <StyledLinkDiv
        onMouseOver={() => {
          const preferCachedValue = true;
          trigger({file: props.file_ref}, preferCachedValue);
        }}
      >
        <i
          className="fa fa-lock text-light"
          aria-hidden="true"
          style={{marginRight: '5px'}}
        ></i>
        <a
          id="SecureLink"
          target="_blank"
          rel="noopener noreferrer"
          href={data?.signed_url}
          onClick={() => {
            if (data?.signed_url == null) {
              // if there is no signed url and someone manages to click, load it now.
              const preferCachedValue = true;
              trigger({file: props.file_ref}, preferCachedValue);
            }
          }}
          className={cs('d-flex align-items-center', {
            'text-danger': !isBigScreen && data?.signed_url == null,
          })}
        >
          {props.file_name}
        </a>
        <StateButton
          onClick={() => {
            const preferCachedValue = false; // hard refresh evict cache
            return trigger({file: props.file_ref}, preferCachedValue);
          }}
          className="btn btn-sm ml-1 text-muted"
          isIdle={!isFetching}
          disabled={isLoading}
          title={gt('Refresh secured link')}
        >
          <i className="fa fa-redo" />
        </StateButton>
      </StyledLinkDiv>
    </LazyTooltip>
  );
}

const StyledLinkDiv = styled.div.attrs({
  className: 'd-inline-flex align-items-center',
})`
  height: calc(1.5em + 2px);
`;
